// Application entry point. Mounts the React app to the DOM.
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  beforeSend(event) {
    const walk = (obj: unknown, depth = 0): void => {
      if (depth > 5 || !obj || typeof obj !== 'object') return;
      const record = obj as Record<string, unknown>;
      Object.keys(record).forEach(k => {
        if (['email', 'name', 'studentName', 'content'].includes(k)) {
          record[k] = '[Scrubbed]';
        } else if (typeof record[k] === 'object') {
          walk(record[k], depth + 1);
        }
      });
    };
    walk(event);
    return event;
  }
});

import './index.css'
import './App.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
